<!--  -->
<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'main-layout',
  data () {
    return {}
  },
  methods: {},
}
</script> 

<style lang='less' scoped>

</style>
